/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import hyperlinkHandler from '../../../hyperlink/handler/dashboardHyperlinkHandlerAdhocExecution';
import dashboardWiringStandardIds from '../../../enum/dashboardWiringStandardIds';
import FreeTextView from '../FreeTextView';
import compTraitUtil from './util/componentTraitUtil';

function signalHandler(payload) {
    if (payload.name === dashboardWiringStandardIds.REFRESH_SLOT || payload.name === dashboardWiringStandardIds.APPLY_SLOT) {
        this._renderComponent();
    }
}

export default {
    notify: function (signals) {
        this.model.notify(signals);
        this.model.collection.getDashboardPropertiesComponent().applyParameters();
    },
    /**
     * @memberof textTrait
     * @access protected
     * @desc initializes FreeTextView component
     */
    _initComponent: function () {
        const self = this;

        this.component = new FreeTextView({
            model: this.model,
            el: this.$content
        });
        this.$content.click(function (ev) {
            compTraitUtil.triggerLinkOptions(ev,self.model);
            hyperlinkHandler.events.click(ev, compTraitUtil.getParameters(self.model), self);
        });
        this.$content.mouseover(function(ev){
            compTraitUtil.triggerLinkOptions(ev,self.model);
        });
        this.$content.mouseout(function(ev){
            compTraitUtil.triggerLinkOptions(ev,self.model);
        });
        this.listenTo(this.model, 'signal', signalHandler);
        if (this.model.lastPayload) {
            for (var key in this.model.lastPayload) {
                signalHandler.call(this, {
                    name: key,
                    value: this.model.lastPayload[key]
                }, this.model.lastSender[key]);
            }
        }
        this.on('componentAttached', this.component.applyFontSize, this.component);
        this.listenTo(this.model.collection.getDashboardPropertiesComponent(), 'change:dashletPadding', function (props, padding) {
            this.component.applyFontSize(padding);
        }, this);
    },
    /**
     * @memberof textTrait
     * @access protected
     * @desc on component properties change event handler. re-Renders component after properties were changed through properties dialog.
     */
    _onComponentPropertiesChange: function () {
        this._renderComponent();
    },
    /**
     * @memberof textTrait
     * @desc renders component
     * @access protected
     * @fires componentRendered
     */
    _renderComponent: function () {
        var text = this.model.getParametrizationResult('text', this.paramsModel.attributes, {tolerateMissing: true});
        this.component.render(text);
        this.trigger('componentRendered', this);
    },
    /**
     * @memberof textTrait
     * @access protected
     * @desc removes component.
     */
    _removeComponent: function () {
        this.component.remove();
        this.off('componentAttached');
        this.stopListening(this.model.collection.getDashboardPropertiesComponent());
    }
};